module.exports = ["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]


//////////////////
// WEBPACK FOOTER
// ./~/html-void-elements/index.json
// module id = 582
// module chunks = 168707334958949